import { render, staticRenderFns } from "./MarketComparison.vue?vue&type=template&id=c9a807e8&scoped=true"
import script from "./MarketComparison.vue?vue&type=script&lang=js"
export * from "./MarketComparison.vue?vue&type=script&lang=js"
import style0 from "./MarketComparison.vue?vue&type=style&index=0&id=c9a807e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a807e8",
  null
  
)

export default component.exports